import _ from 'lodash';
import fHelper from 'helpers/financials-helper';
import { VALUES_VERSION } from '../localstorage-keys';
import rHelper from '../reducers/reducer-helpers';
import { getSectionFields } from 'helpers/form-config-helpers';
import { sameAsFlag } from 'helpers/model-helpers';

//The URL of the Firebase Cloud Functions
export const API_URL = process.env.REACT_APP_SERVER_URL;
//TODO: TESTING
// export const MERGE_URL = "http://localhost:7224/api/merge-and-export";
export const MERGE_URL = process.env.REACT_APP_EXPORT_FN_URL;

//----------------------
// Transforms the pagination structure into the correct format
//----------------------
export const transformPagination = (pagination) => {
    if(!pagination) return {};  //no pagination info
    if(pagination.offset && pagination.limit) return pagination;    //already transformed
    if(!pagination.pageNum || !pagination.pageSize) throw new Error("invalid pagination information passed to transformPagination");

    return {
        offset  : (pagination.pageNum-1) * pagination.pageSize,
        limit   : pagination.pageSize
    };
}

//----------------------
// Adds the query parameters and pagination information to the url
//----------------------
export const addQueryParameters = (url, pagination, queryParameters) => {
    
    if(pagination == null && queryParameters == null) return url;
    
    const myPagination  = transformPagination(pagination);    
    const allParams     = _.merge({}, myPagination, queryParameters);
    const qps           = _.compact(_.map(allParams, (value, key) => { return value ? `${encodeURIComponent(key)}=${encodeURIComponent(value)}` : null}));
    const qstring       = qps && qps.length > 0 ? qps.join("&") : null;
    
    return url + (qstring ? `?${qstring}` : "");
}

//----------------------
// Transforms the raw data into the format to send to the merge function
//----------------------
export const prepareForMerge = (data, regions, allFields) => {
    let totals          = {};
    _.forEach(regions, region => {
        if(region.totals){

            region.sections.forEach(section => {
                const secId     = `t_${region.id}_${section.id}`;
                const sectionFields = getSectionFields(section, allFields, region.id);
                //TODO: pass in the SECTION fields
                totals[secId]   = fHelper.calculateSectionTotal(section, data, undefined, sectionFields);

                //Check to see if there are other fields that need to be totaled
                //TODO: pass in fields
                const otherTotals   = fHelper.getOtherTotals(region, section, data, allFields);
                if(otherTotals) totals = {...totals, ...otherTotals};

                //Check for list row total fields
                if(section.type === "list" && section.rowTotalFields){
                    //TODO: pass in fields
                    const updatedRows   = fHelper.addRowTotals(section, data, allFields);
                    data[section.id]    = updatedRows;
                }

                if(section.type === "list" && section.addOptionNames){
                    //TODO: pass in fields
                    const withNames   = fHelper.addRowOptionNames(section, data, allFields);
                    data[section.id]  = withNames;
                }
            });

            const rId           = `t_${region.id}`;
            //TODO: pass in fields
            totals[rId]         = fHelper.calculateRegionTotal(region, data, undefined, allFields);
        }
        else if(region.type === "summary"){
            //this is a summary region, so need to handle it a little different
            const fields    = fHelper.getFields(region.fields, undefined, allFields);
            _.forEach(fields, field => {
                let total   = 0;
                if(field.calculation){
                    total   = fHelper.calculateSummaryField(field, data, regions);
                }
                else{
                    total   = fHelper.calculateSummaryRegion(field, data, regions);
                }

                const rId   = `s_${field.id}`;
                totals[rId] = total;
            });
        }
    });

    return {...data, ...totals};
}

//----------------------
// Converts the data into a blob, and triggers a download
//----------------------
export const downloadRaw = (state) => {

    const preped    = prepareValuesLocal(state);

    //Create a blob with the json data
    const blob = new Blob([JSON.stringify(preped, null, 2)], {type : 'application/json'});
    const fileName  = "FigurEx-raw.json";

    var linkElement = document.createElement('a');
    try {
        //To get the file to download, need to create a virtual link pointed to the file url and "click" it.
        var url = window.URL.createObjectURL(blob);
        linkElement.setAttribute('href', url);
        linkElement.setAttribute("download", fileName);

        var clickEvent = new MouseEvent("click", {
            "view": window,
            "bubbles": true,
            "cancelable": false
        });
        linkElement.dispatchEvent(clickEvent);

        return true;    //indicate it worked

    } catch (ex) {
        console.log(ex);
        return false;
    }
}

//----------------------
// Prepares the data to be downloaded / saved
//----------------------
// const toOmit = ["meta", "local", "database", "isDirty", "a_isLoaded", "a_lastModified", "reviewers", "reviewerStatus", "forms"];
export const prepareValues = (state) => {
    const vData     = state.values;
    const aData     = state.app;
    const timestamp = rHelper.getCurrentDateTime();

    //pull out the fields that aren't part of the values document
    const { meta, local, database, isDirty, a_isLoaded, a_lastModified, reviewers, reviewerStatus, forms, ...rest } = vData;

    const values    = {
        appVersion  : VALUES_VERSION,
        uid         : state.app.profile.uid,
        email: state.app.profile.email,
        reviewers   : vData.reviewers || [],
        // values      : _.omit(vData, toOmit),
        values: rest,
        meta        : {
            locationKey     : aData.profile.locationKey || "",
            locationVersion : aData.locationVersion || "",
            lastSaved       : vData.database.savedAt || vData.local.savedAt || "",
            preparedAt      : timestamp,
        },
        
    }

    return values;
}

//----------------------
// Prepares the data to be downloaded / saved
//----------------------
export const prepareValuesLocal = (state) => {
    const vData     = state.values;
    const aData     = state.app;
    const timestamp = rHelper.getCurrentDateTime();

    const { meta, local, database, isDirty, a_isLoaded, a_lastModified, reviewers, reviewerStatus, forms, ...rest } = vData;
    
    const values    = {
        appVersion  : VALUES_VERSION,
        values      : rest, //_.omit(vData, ["meta", "local", "database", "isDirty", "a_isLoaded", "a_lastModified", "reviewers", "reviewerStatus"]),
        meta        : {
            locationKey     : aData.profile.locationKey,
            locationVersion : aData.locationVersion,
            lastSaved       : vData.database.savedAt || timestamp,
            preparedAt      : timestamp,
        },
        
    }

    return values;
}

export function getNowString(){
    return new Date().toISOString();
}

export function getNow(){
    return new Date();   
}